import React, { useCallback, useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import MaterialTable from "./TaskTable";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import InventoryModal from "../../components/modals/InventoryModal";
import { usersData } from "../../store/reducer/usersSlice";
import { useAppSelector } from "../../utils/hooks";
import { useSelector } from "react-redux";
import {
  deleteComplaints,
  getAllComplaints,
  saveComplaint,
  updateComplaint,
} from "../../api/restApi";
import ChatModal from "./chat/ChatModal";
const Complaint = () => {
  const user = useSelector((state) => state.currentUser);
  console.log(user)
  const role=user.role;
  const name=user.name;
  const { users } = useAppSelector(usersData);
  console.log(users);
  const userName = users.map((user) => {
    return user.name;
  });

  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [inventoryModal, setInventoryModal] = useState(false);
  const [complaints, setComplaints] = useState([]);
  const [rowData,setRowData]=useState();
  useEffect(() => {
    getComplaintData();
  }, []);

  const getComplaintData = async () => {
    let response = await getAllComplaints();
    setComplaints(response);
    console.log(response);
  };

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      size: 80,
    },
    {
      accessorKey: "name",
      header: "Task Name",
      enableEditing: false,
      size: 140,
    },
    {
      accessorKey: "assignTo",
      header: "Assign to",
      enableEditing: false,
      // editVariant: 'select',
      // editSelectOptions: ["Close", "Open", "In Review", "In Progress"],
      size: 140,
    },
    {
      accessorKey: "priority",
      header: "Priority",
      editVariant: "select",
      editSelectOptions: ["Urgent", "High", "Normal", "Low"],
      size: 140,
    },
    {
      accessorKey: "taskStatus",
      header: "Task Status",
      editVariant: "select",
      editSelectOptions: ["Close", "Open", "In Review", "In Progress"],
      size: 140,
    },
    {
      accessorKey: "dueDate",
      header: "Completion Date",
      enableEditing: false,
      size: 140,
    },
  ]);


  const filteredData = complaints.filter((item) => item.assignTo === name);
  console.log(complaints, filteredData)

  const handleCreateNewRow = async (values) => {
    try {
      console.log(values);
      const newValues={...values}
      let response = await saveComplaint(newValues);
      console.log(response);

      toast.success("Successfully add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      getComplaintData();
    } catch (error) {
      console.log(error);
      toast.error("Failed to add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleDeleteRow = useCallback(async (row) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      try {
        let id = row.getValue("id").toString();
        console.log(row.getValue("id"));
        let response = await deleteComplaints(id);
        console.log(response);
        toast.success("Successfully deleted  item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        getComplaintData();
      } catch (error) {
        console.log(error);
        toast.error("Failed to  delete  item!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } else {
      return;
    }
  });

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    console.log(row, values);
    try {
      let id = row.getValue("id").toString();
      let response = await updateComplaint(values, id);
      console.log(response);
      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      getComplaintData();
    } catch (error) {
      console.log(error);
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    exitEditingMode(); //required to exit editing mode and close modal
    // }
  };

  const handleOpenTimeline=(row)=>{
    console.log(row)
    setRowData(row)
    setInventoryModal(true)
  }

  useEffect(()=>{

  },[rowData])

  return (
    <div>
      <MaterialTable
        tableData={role === "head" ? complaints : filteredData}
        setCreateModalOpen={setTaskModalOpen}
        handleSaveRowEdits={handleSaveRowEdits}
        //   handleCancelRowEdits={handleCancelRowEdits}
        handleDeleteRow={handleDeleteRow}
        columns={columns}
        handleOpenTimeline={handleOpenTimeline}
        role={role}
      />
      <TaskModal
        columns={columns}
        open={taskModalOpen}
        onClose={() => setTaskModalOpen(false)}
        userName={userName}
        onSubmit={handleCreateNewRow}
      />
      <ChatModal
        open={inventoryModal}
        handleClose={() => setInventoryModal(false)}
        rowData={rowData}

      />
    </div>
  );
};

export default Complaint;

export const TaskModal = ({ open, columns, onClose, onSubmit, userName }) => {
  console.log(columns);
  const priority = ["Urgent", "High", "Normal", "Low"];
  const [values, setValues] = useState({});
  const today = dayjs();
  console.log(today.toDate())
  const statusOptions = ["Close", "Open", "In Review", "In Progress"];

  const handleSubmit = async () => {
    onSubmit(values);
    onClose();
    console.log(values);
  };

  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Assign New Task</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "200px", sm: "260px", md: "400px" },
              gap: "1.5rem",
              paddingTop: "0.5rem",
            }}
          >
            {columns.map((column) => {
              if (
                column.accessorKey !== "id" &&
                column.accessorKey !== "priority" &&
                column.accessorKey !== "assignTo" &&
                column.accessorKey !== "taskStatus" &&
                column.accessorKey !== "dueDate"
              ) {
                return (
                  <TextField
                    key={column.accessorKey}
                    label={column.header}
                    name={column.accessorKey}
                    onChange={(e) =>
                      setValues({ ...values, [e.target.name]: e.target.value })
                    }
                  />
                );
              } else if (column.accessorKey === "assignTo") {
                return (
                  <Autocomplete
                    key={column.accessorKey}
                    options={userName}
                    getOptionLabel={(option) => option}
                    value={values.assignTo || null}
                    onChange={(e, newValue) =>
                      setValues({ ...values, assignTo: newValue })
                    }
                    renderInput={(params) => (
                      <TextField {...params} label={column.header} />
                    )}
                  />
                );
              } else if (column.accessorKey === "priority") {
                return (
                  <Autocomplete
                    key={column.accessorKey}
                    variant="standard"
                    options={priority}
                    getOptionLabel={(option) => option}
                    value={values.priority || null} // Change 'values.category_english' to 'values.recipe'
                    onChange={(e, newValue) =>
                      setValues({ ...values, priority: newValue })
                    } // Change 'recipe_english' to 'recipe'
                    renderInput={(params) => (
                      <TextField {...params} label={column.header} />
                    )}
                  />
                );
              } else if (column.accessorKey === "taskStatus") {
                return (
                  <Autocomplete
                    key={column.accessorKey}
                    variant="standard"
                    options={statusOptions}
                    getOptionLabel={(option) => option}
                    value={values.taskStatus || null} // Change 'values.category_english' to 'values.recipe'
                    onChange={(e, newValue) =>
                      setValues({ ...values, taskStatus: newValue })
                    } // Change 'recipe_english' to 'recipe'
                    renderInput={(params) => (
                      <TextField {...params} label={column.header} />
                    )}
                  />
                );
              } else if (column.accessorKey === "dueDate") {
                return (
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    key={column.accessorKey}
                  >
                    <DatePicker
                      label={column.header}
                      value={values.dueDate ? dayjs(values.dueDate) : null}
                      onChange={(newValue) =>
                        setValues({
                          ...values,
                          dueDate: newValue.format("MM/DD/YYYY"),
                        })
                      }
                      renderInput={(params) => <TextField {...params} />}
                      // minDate={today.toDate()}
                    />
                  </LocalizationProvider>
                );
              }
            })}
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose} variant="contained">
          Cancel
        </Button>
        <Button color="secondary" onClick={handleSubmit} variant="contained">
          Assign New Task
        </Button>
      </DialogActions>
    </Dialog>
  );
};